<template>
  <div class="waiting-page">
    <div class="waiting-page-content">
      <div class="waiting-page-icon">
        <img
          class="waiting-page-icon__img"
          src="../../assets/gear-icon.svg"
          alt="Gears Icon"
        />
      </div>
      <h1 class="waiting-page-title">
        Wasza aplikacja jest w trakcie tworzenia.
      </h1>
      <p class="waiting-page-subtitle">
        Kod QR, który od nas otrzymaliście, jest już gotowy do wydrukowania.
      </p>
    </div>
    <div class="waiting-page-footer">
      <div class="waiting-page-footer-content">
        <img
          class="waiting-page-footer-logo"
          src="../../assets/main/logo.svg"
          alt="Wspomnienia z Wesela Logo"
        />
        <span class="waiting-page-footer-text">WSPOMNIENIA Z WESELA</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$background-color: #f8f1e8;
$text-color: #000;

.waiting-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 100vh;
  background-color: $background-color;
  color: $text-color;
  font-family: Georgia, serif;
  text-align: center;
  padding: 20px;
  font-size: 16px;

  &-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
  }

  &-title {
    font-size: 1.8rem;
    font-weight: bold;
    margin-bottom: 10px;
    line-height: 2rem;
  }

  &-subtitle {
    font-size: 1rem;
  }

  &-icon {
    margin-bottom: 20px;

    &__img {
      width: 100px;
    }
  }

  &-footer {
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    &-content {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    &-logo {
      width: 30px;
    }

    &-text {
      font-size: 0.9rem;
    }
  }
}
</style>
